<template>
  <div class="w-full min-h-screen">
    <!-- HEADING -->
    <div class="lg:h-72 flex justify-start items-end p-12 bg-gray-200">
      <div
        class="h-32 border-l-4 pl-6 border-black flex flex-col justify-end items-end m-0 p-0 w-full"
      >
        <h1 class="w-full text-left">Automations</h1>
        <span class="text-md w-full text-left"
          >Take a break and let Automations update your Careers Website or send
          your newsletter automatically.</span
        >
      </div>
    </div>

    <!-- CONTENT -->
    <div
      class="bg-truegray-700 w-full pb-16 flex flex-col items-center lg:items-start"
    >
      <div
        class="bg-white rounded-xl lg:ml-16 mt-16 p-6 lg:p-12 relative z-20 w-11/12 lg:w-9/12"
        :style="{ background: '#fafbfc' }"
      >
        <div class="mb-8">
          <h3 class="mb-2">Cloud Automation</h3>
          <div
            v-if="cloudForm.cloudAutoMode && cloudFormInitial.cloudAutoMode"
            class="flex items-center space-x-4 w-full text-cw-700"
          >
            <p class="text-sm m-0">
              Cloud posts being automatically pulled once a day
            </p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              class="w-4 h-4"
            >
              <path
                d="M15.98 1.804a1 1 0 0 0-1.96 0l-.24 1.192a1 1 0 0 1-.784.785l-1.192.238a1 1 0 0 0 0 1.962l1.192.238a1 1 0 0 1 .785.785l.238 1.192a1 1 0 0 0 1.962 0l.238-1.192a1 1 0 0 1 .785-.785l1.192-.238a1 1 0 0 0 0-1.962l-1.192-.238a1 1 0 0 1-.785-.785l-.238-1.192ZM6.949 5.684a1 1 0 0 0-1.898 0l-.683 2.051a1 1 0 0 1-.633.633l-2.051.683a1 1 0 0 0 0 1.898l2.051.684a1 1 0 0 1 .633.632l.683 2.051a1 1 0 0 0 1.898 0l.683-2.051a1 1 0 0 1 .633-.633l2.051-.683a1 1 0 0 0 0-1.898l-2.051-.683a1 1 0 0 1-.633-.633L6.95 5.684ZM13.949 13.684a1 1 0 0 0-1.898 0l-.184.551a1 1 0 0 1-.632.633l-.551.183a1 1 0 0 0 0 1.898l.551.183a1 1 0 0 1 .633.633l.183.551a1 1 0 0 0 1.898 0l.184-.551a1 1 0 0 1 .632-.633l.551-.183a1 1 0 0 0 0-1.898l-.551-.184a1 1 0 0 1-.633-.632l-.183-.551Z"
              />
            </svg>
          </div>
        </div>
        <FormulateForm
          v-model="cloudForm"
          class="w-full"
          @submit="cloudOnSubmit"
        >
          <div class="w-full flex justify-start items-center mt-4">
            <!--
              <button
              type="button"
              :class="[
              cloudForm.cloudAutoMode ? 'bg-primary' : 'bg-gray-200',
              'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-all ease-in-out duration-200 focus:outline-none mb-4',
              ]"
              role="switch"
              aria-checked="false"
              @click="toggleCloudAutoModeStatus"
              >
              <span
              aria-hidden="true"
              class="pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transcloudForm transition-all ring-0 ease-in-out duration-200"
              :class="[
              cloudForm.cloudAutoMode ? 'translate-x-5' : 'translate-x-0',
              ]"
              ></span>
              </button> 
            -->
            <button
              type="button"
              :class="['btn bg-white border-none automation-btn group m-0']"
              :style="cloudForm.cloudAutoMode ? activeStyles : inactiveStyles"
              @click="toggleCloudAutoModeStatus"
            >
              <div
                :class="[cloudForm.cloudAutoMode ? 'text-cw-700' : '']"
                class="svg group-hover:text-cw-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  class="w-4 h-4 mr-4 transform transition-all group-hover:rotate-90"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8.34 1.804A1 1 0 0 1 9.32 1h1.36a1 1 0 0 1 .98.804l.295 1.473c.497.144.971.342 1.416.587l1.25-.834a1 1 0 0 1 1.262.125l.962.962a1 1 0 0 1 .125 1.262l-.834 1.25c.245.445.443.919.587 1.416l1.473.294a1 1 0 0 1 .804.98v1.361a1 1 0 0 1-.804.98l-1.473.295a6.95 6.95 0 0 1-.587 1.416l.834 1.25a1 1 0 0 1-.125 1.262l-.962.962a1 1 0 0 1-1.262.125l-1.25-.834a6.953 6.953 0 0 1-1.416.587l-.294 1.473a1 1 0 0 1-.98.804H9.32a1 1 0 0 1-.98-.804l-.295-1.473a6.957 6.957 0 0 1-1.416-.587l-1.25.834a1 1 0 0 1-1.262-.125l-.962-.962a1 1 0 0 1-.125-1.262l.834-1.25a6.957 6.957 0 0 1-.587-1.416l-1.473-.294A1 1 0 0 1 1 10.68V9.32a1 1 0 0 1 .804-.98l1.473-.295c.144-.497.342-.971.587-1.416l-.834-1.25a1 1 0 0 1 .125-1.262l.962-.962A1 1 0 0 1 5.38 3.03l1.25.834a6.957 6.957 0 0 1 1.416-.587l.294-1.473ZM13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>

              <span v-if="!cloudForm.cloudAutoMode" aria-hidden="true" class=""
                >Activate</span
              >
              <span v-if="cloudForm.cloudAutoMode" aria-hidden="true" class=""
                >Deactivate</span
              >
            </button>

            <span
              class="ml-6 text-truegray-500 text-xs cursor-pointer hover:text-cw-700 hover:underline"
              @click="toggleCloudAutoModeDescription"
              >what's this?</span
            >
          </div>

          <div
            v-if="cloudForm.cloudAutoMode"
            class="w-full flex justify-start items-center space-x-3 mt-6"
          >
            <button
              type="button"
              :class="[
                expiryStatus ? 'bg-gray-200' : 'bg-cw-700',
                'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-all ease-in-out duration-200 focus:outline-none mb-4',
              ]"
              role="switch"
              aria-checked="false"
              @click="toggleExpiryStatus"
            >
              <span
                aria-hidden="true"
                class="pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform transition-all ring-0 ease-in-out duration-200"
                :class="[expiryStatus ? 'translate-x-0' : 'translate-x-5']"
              ></span>
            </button>
            <span v-if="!expiryStatus" class="mb-4">Always on</span>
            <span v-else class="mb-4">Turn on until:</span>
          </div>

          <div v-if="cloudForm.cloudAutoMode && expiryStatus">
            <date-picker
              v-model="cloudForm.cloudAutoModeExpiresAt"
              value="datetime"
              value-type="format"
              format="DD-MM-YYYY"
            ></date-picker>
          </div>

          <button
            type="submit"
            :disabled="areCloudFormsEqual"
            class="btn mt-6 mb-4 h-10"
            :class="[
              areCloudFormsEqual
                ? 'opacity-40 cursor-not-allowed'
                : 'opacity-100',
              isCloudSubmitting ? 'btn-trans-black' : 'btn-cw-700',
            ]"
          >
            <span v-if="isCloudSubmitting" class="h-6">
              <lottie :options="loadingAnimationOptions" />
            </span>
            <span v-else>Save</span>
          </button>

          <div
            v-if="cloudAutoModeDescriptionVisible"
            class="bg-truegray-100 rounded-xl p-4"
          >
            <p class="text-sm mb-4">
              Cloud Automations mode is a way to automate your CareerWise
              website post content, either for a period of time, or even
              permanently.
            </p>
            <p class="text-sm mb-4">
              While active, all posts from the CareerWise Cloud that are
              relevant to your region will automatically be pulled each day.
              This means any post tagged as 'All Regions' or the region your
              school is in.
            </p>
            <p class="text-sm italic mt-8">Please note:</p>

            <p class="text-sm italic text-cw-700 mb-4">
              We highly recommend turning on the automated newsletter while you
              have this enabled to continue to drive traffic to your CareerWise
              website.
            </p>
            <p class="text-sm italic">Disclaimer:</p>
            <p class="text-sm text-truegray-500 italic">
              This will mean that if multiple schools were to post the same
              article or event and there was a double up in the cloud, you would
              pull both. While this is a great feature to save time, be wary
              that you do lose control of which content you want.
            </p>
          </div>
        </FormulateForm>

        <div class="mb-8">
          <h3 class="mt-12 pt-12 border-t border-truegray-300 mb-2">
            Newsletter Automation
          </h3>
          <div
            v-if="
              newsletterAutoModeStatus?.title &&
              !newsletterAutoModeStatusLoading
            "
            class="rounded-xl"
          >
            <div
              class="py-2 flex items-center space-x-4 cursor-pointer text-sm m-0 text-cw-700"
              :class="newsletterDetailsOpen ? 'rounded-t-xl' : 'rounded-xl'"
              @click="toggleNewsletterStatusDD"
            >
              Automatic Newsletter Enabled
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                class="w-4 h-4 ml-4"
              >
                <path
                  d="M15.98 1.804a1 1 0 0 0-1.96 0l-.24 1.192a1 1 0 0 1-.784.785l-1.192.238a1 1 0 0 0 0 1.962l1.192.238a1 1 0 0 1 .785.785l.238 1.192a1 1 0 0 0 1.962 0l.238-1.192a1 1 0 0 1 .785-.785l1.192-.238a1 1 0 0 0 0-1.962l-1.192-.238a1 1 0 0 1-.785-.785l-.238-1.192ZM6.949 5.684a1 1 0 0 0-1.898 0l-.683 2.051a1 1 0 0 1-.633.633l-2.051.683a1 1 0 0 0 0 1.898l2.051.684a1 1 0 0 1 .633.632l.683 2.051a1 1 0 0 0 1.898 0l.683-2.051a1 1 0 0 1 .633-.633l2.051-.683a1 1 0 0 0 0-1.898l-2.051-.683a1 1 0 0 1-.633-.633L6.95 5.684ZM13.949 13.684a1 1 0 0 0-1.898 0l-.184.551a1 1 0 0 1-.632.633l-.551.183a1 1 0 0 0 0 1.898l.551.183a1 1 0 0 1 .633.633l.183.551a1 1 0 0 0 1.898 0l.184-.551a1 1 0 0 1 .632-.633l.551-.183a1 1 0 0 0 0-1.898l-.551-.184a1 1 0 0 1-.633-.632l-.183-.551Z"
                />
              </svg>
              <span
                class="text-truegray-500 text-xs cursor-pointer hover:text-cw-700 hover:underline"
                >details</span
              >
            </div>
            <div
              v-if="newsletterDetailsOpen"
              class="py-4 px-8 border border-truegray-300 bg-truegray-100 rounded-xl mt-6"
              :style="{ width: 'max-content' }"
            >
              <h3 class="text-xs font-bold text-cw-700 mb-2">
                Automation Status:
              </h3>
              <p class="text-truegray-500 text-sm">
                Title:
                <span class="text-black text-base ml-2">{{
                  newsletterAutoModeStatus.title
                }}</span>
              </p>
              <p class="text-truegray-500 text-sm">
                Subject:
                <span class="text-black text-base ml-2">{{
                  newsletterAutoModeStatus.subject
                }}</span>
              </p>
              <p class="text-truegray-500 text-sm">
                Send Day:
                <span class="text-black text-base ml-2">{{
                  newsletterAutoModeStatus.day
                }}</span>
              </p>
              <p class="text-truegray-500 text-sm">
                Send Time:
                <span class="text-black text-base ml-2">{{
                  newsletterAutoModeStatus.time
                }}</span>
              </p>

              <p
                v-if="newsletterAutoModeMailLists"
                class="text-truegray-500 text-sm"
              >
                Send To:
                <span class="text-black text-base ml-2">{{
                  newsletterAutoModeMailLists
                }}</span>
              </p>

              <p class="text-truegray-500 text-sm">
                Last Sent:
                <span
                  v-if="newsletterAutoModeStatus.lastSent"
                  class="text-black text-base ml-2"
                  >{{ newsletterAutoModeStatus.lastSent }}</span
                >
                <span v-else class="text-black text-base ml-2">Never</span>
              </p>
            </div>
          </div>
        </div>

        <button
          type="button"
          :class="[
            newsletterMailListsLoading ? 'cursor-not-allowed opacity-50' : '',
            'btn bg-white border-none automation-btn group m-0',
          ]"
          :style="
            newsletterAutoModeStatus?.title && !newsletterAutoModeStatusLoading
              ? activeStyles
              : inactiveStyles
          "
          :disabled="newsletterMailListsLoading"
          role="switch"
          aria-checked="false"
          @click="handleAutoNewsletterClick"
        >
          <div v-if="newsletterMailListsLoading" class="">
            <div class="h-6 w-20">
              <lottie :options="loadingAnimationOptions" />
            </div>
          </div>
          <div v-else class="flex">
            <div
              :class="[cloudForm.cloudAutoMode ? 'text-cw-700' : '']"
              class="svg group-hover:text-cw-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                class="w-4 h-4 mr-4 transform transition-all group-hover:rotate-90"
              >
                <path
                  fill-rule="evenodd"
                  d="M8.34 1.804A1 1 0 0 1 9.32 1h1.36a1 1 0 0 1 .98.804l.295 1.473c.497.144.971.342 1.416.587l1.25-.834a1 1 0 0 1 1.262.125l.962.962a1 1 0 0 1 .125 1.262l-.834 1.25c.245.445.443.919.587 1.416l1.473.294a1 1 0 0 1 .804.98v1.361a1 1 0 0 1-.804.98l-1.473.295a6.95 6.95 0 0 1-.587 1.416l.834 1.25a1 1 0 0 1-.125 1.262l-.962.962a1 1 0 0 1-1.262.125l-1.25-.834a6.953 6.953 0 0 1-1.416.587l-.294 1.473a1 1 0 0 1-.98.804H9.32a1 1 0 0 1-.98-.804l-.295-1.473a6.957 6.957 0 0 1-1.416-.587l-1.25.834a1 1 0 0 1-1.262-.125l-.962-.962a1 1 0 0 1-.125-1.262l.834-1.25a6.957 6.957 0 0 1-.587-1.416l-1.473-.294A1 1 0 0 1 1 10.68V9.32a1 1 0 0 1 .804-.98l1.473-.295c.144-.497.342-.971.587-1.416l-.834-1.25a1 1 0 0 1 .125-1.262l.962-.962A1 1 0 0 1 5.38 3.03l1.25.834a6.957 6.957 0 0 1 1.416-.587l.294-1.473ZM13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>

            <span
              v-if="
                !newsletterAutoModeStatus?.title &&
                !newsletterAutoModeStatusLoading
              "
              aria-hidden="true"
              class=""
              >Activate</span
            >
            <span
              v-if="
                newsletterAutoModeStatus?.title &&
                !newsletterAutoModeStatusLoading
              "
              aria-hidden="true"
              class=""
              >Deactivate</span
            >
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted, watch } from 'vue'
import { EventBus } from '../../../../js/plugins/event-bus.js'
import { useStore } from '../../../../js/store/index.js'
import * as loadingAnimation from '../../../../shared/components/loading-dark.json'
import DatePicker from 'vue2-datepicker'

export default defineComponent({
  name: 'AutoNewsletterModal',
  components: { DatePicker },

  setup() {
    // CONFIG
    const store = useStore()
    const loadingAnimationOptions = { animationData: loadingAnimation.default }
    const isCloudSubmitting = ref(false)

    const settings = computed(() => store.getters['shared/getSettings'])

    watch(settings, () => {
      initCloud()
    })
    const inactiveStyles = [
      {
        boxShadow:
          'inset 0 -2px 6px rgba(218,225,230,.2),0 0 0 1px rgba(90,101,112,.05),0 1px 2px rgba(90,101,112,.22)',
      },
    ]

    const activeStyles = [
      {
        boxShadow: `inset 0 1px 0 rgba(212, 220, 227, 0.7), inset 0 0 1px #d4dce3, 0 1px 0 #fff`,
      },
      {
        background: '#f5f7f8',
      },
    ]

    // CLOUD
    const cloudForm = ref({
      cloudAutoMode: false,
      cloudAutoModeExpiresAt: null,
    })

    watch(cloudForm, () => {
      if (!cloudForm.value.cloudAutoMode) {
        cloudForm.value.cloudAutoModeExpiresAt = null
      }
    })

    const cloudFormInitial = ref({
      cloudAutoMode: false,
      cloudAutoModeExpiresAt: null,
    })

    const areCloudFormsEqual = computed(() => {
      return (
        JSON.stringify(cloudForm.value) ===
        JSON.stringify(cloudFormInitial.value)
      )
    })

    const cloudAutoModeDescriptionVisible = ref(false)

    const toggleCloudAutoModeDescription = () => {
      cloudAutoModeDescriptionVisible.value =
        !cloudAutoModeDescriptionVisible.value
    }

    const toggleCloudAutoModeStatus = () => {
      cloudForm.value.cloudAutoMode = !cloudForm.value.cloudAutoMode
    }

    const expiryStatus = ref(false)

    const toggleExpiryStatus = () => {
      expiryStatus.value = !expiryStatus.value
    }

    watch(expiryStatus, () => {
      if (!expiryStatus.value) {
        cloudForm.value.cloudAutoModeExpiresAt = null
      }
    })

    const cloudOnSubmit = async () => {
      isCloudSubmitting.value = true
      await store.dispatch('careerwise/dispatchUpdateCloudAutoModeStatus', {
        payload: cloudForm.value,
      })
      EventBus.$emit('reloadWebsiteSettings')
      isCloudSubmitting.value = false
    }

    const initCloud = () => {
      cloudForm.value.cloudAutoMode = !!settings.value?.auto_mode
      cloudForm.value.cloudAutoModeExpiresAt =
        settings.value?.auto_mode_expires_at

      cloudFormInitial.value.cloudAutoMode = !!settings.value?.auto_mode
      cloudFormInitial.value.cloudAutoModeExpiresAt =
        settings.value?.auto_mode_expires_at

      expiryStatus.value = settings.value?.auto_mode_expires_at ? true : false
    }

    // NEWSLETTER
    const newsletterAutoModeStatusLoading = ref(false)
    const newsletterDetailsOpen = ref(false)
    const newsletterMailListsLoading = ref(false)

    const getMailListsByHailIds = computed(
      () => store.getters['careerwise/getMailListsByHailIds'],
    )

    const newsletterAutoModeStatus = computed(
      () => store.getters['careerwise/getAutoNewsletterStatus'],
    )

    const newsletterMailLists = computed(() => {
      const listsSentTo = this.getMailListsByHailIds(
        this.autoNewsletterStatus?.mailLists,
      )
      const names = listsSentTo.map((list) => list.name)
      return names.join(', ')
    })

    const initNewsletter = async () => {
      newsletterAutoModeStatusLoading.value = true
      await store.dispatch('careerwise/dispatchGetAutoNewsletterStatus')
      newsletterAutoModeStatusLoading.value = false
    }

    const handleAutoNewsletterClick = () => {
      if (!newsletterAutoModeStatus.value?.title) {
        EventBus.$emit('showModal', 'autoNewsletterModal')
      } else {
        store.dispatch('careerwise/dispatchTurnOffAutoNewsletter')
      }
    }

    const toggleNewsletterStatusDD = () => {
      newsletterDetailsOpen.value = !newsletterDetailsOpen.value
    }

    const initMailLists = async () => {
      newsletterMailListsLoading.value = true
      await store.dispatch('careerwise/dispatchInitFollowers', true)
      newsletterMailListsLoading.value = false
    }

    const newsletterAutoModeMailLists = computed(() => {
      const mailLists = JSON.parse(
        newsletterAutoModeStatus.value?.mailLists ?? '[]',
      )

      const listsSentTo =
        store.getters['careerwise/getMailListsByHailIds'](mailLists)
      const names = listsSentTo.map((list) => list.name)
      return names.join(', ')
    })

    onMounted(async () => {
      initNewsletter()
      initCloud()
      initMailLists()
      EventBus.$on('autoNewsletterStatusChanged', () => {
        initNewsletter()
      })
    })

    return {
      loadingAnimationOptions,
      isCloudSubmitting,
      inactiveStyles,
      activeStyles,
      cloudForm,
      cloudFormInitial,
      areCloudFormsEqual,
      cloudOnSubmit,
      expiryStatus,
      toggleExpiryStatus,
      cloudAutoModeDescriptionVisible,
      toggleCloudAutoModeDescription,
      toggleCloudAutoModeStatus,
      initNewsletter,
      newsletterAutoModeStatusLoading,
      newsletterMailListsLoading,
      newsletterDetailsOpen,
      getMailListsByHailIds,
      newsletterAutoModeStatus,
      newsletterMailLists,
      handleAutoNewsletterClick,
      toggleNewsletterStatusDD,
      newsletterAutoModeMailLists,
    }
  },
})
</script>

<style scoped>
.automation-btn:active {
  box-shadow: inset 0 1px 0 rgba(212, 220, 227, 0.7), inset 0 0 1px #d4dce3,
    0 1px 0 #fff !important;
  background: #f5f7f8 !important;
}

.automation-btn:hover {
  color: #666;
}
</style>
